/**
 * Per-report PDF layout settings, keyed by report slug. The one place a report's PDF is tuned:
 * the viewer and the server-side renderer both read it through prepareReportPdf, so a change
 * here reaches every PDF of that report.
 */

// Tabloid landscape, 1224pt wide, less 48pt of page padding.
export const PDF_PAGE_WIDTH_PT = 1176;

export const DEFAULT_ROWS_PER_PAGE = 40;

// Largest PDF the browser is asked to build. @react-pdf's layout cost grows faster than page count
// and a browser tab has far less memory than the server renderer: 144 pages renders in about 3
// minutes, while 605 pages never finished in 30. Bigger reports go through a PDF subscription,
// which the server renders up to its own, higher ceiling.
export const BROWSER_MAX_PDF_PAGES = 300;

// Rows per page where a report's row height differs from the default.
export const PDF_ROWS_PER_PAGE = {
  'slugRptStd-Des-Cable_Schedule': 37,
  'slugRptStd-Sub-Instrument_Device_Index': 18,
};

// Smaller font keeps the summed minimum column widths under the page width.
export const PDF_FONT_SIZE_OVERRIDES = {
  'slugRptStd-Gen-IO_Assignments': 6,
  'slugRptStd-Sub-Instrument_Device_Index': 6,
};

// Points moved between columns after the widths are computed. Deltas sum to zero so the table
// still spans the page.
export const PDF_WIDTH_TRANSFERS_PT = {
  'slugRptStd-Net-Network_Connections': { Comment: -10, Source: 10 },
  'slugRptStd-Net-Serial_Connections': { Model: -60, Panel: 20, Parent: 20, Source: 20 },
};

export const rowsPerPageFor = (reportSlug) => PDF_ROWS_PER_PAGE[reportSlug] ?? DEFAULT_ROWS_PER_PAGE;
